import React from 'react'
// nodejs library that concatenates classes
import classNames from 'classnames'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'

// core components
import MyHeader from 'components/Header/MyHeader.js'
import MyFooter from 'components/Footer/MyFooter.js'
import MyHeaderLinks from 'components/Header/MyHeaderLinks.js'

import GridContainer from 'components/Grid/GridContainer.js'
import GridItem from 'components/Grid/GridItem.js'
import Parallax from 'components/Parallax/Parallax.js'
import Card from 'components/Card/Card.js'

import styles from 'assets/jss/material-kit-react/views/casePage.js'
import { Tabs, Tab, CardMedia, Typography, CardContent, ListItem, ListItemIcon, ListItemText, List } from '@material-ui/core'

import zjg from 'assets/img/casePage/lvjian-zjg.jpg'
import ls from 'assets/img/casePage/lvjian-ls.jpg'
import tz from 'assets/img/casePage/lvjian-tz.jpg'
import bu from 'assets/img/casePage/lvjian-bu.png'
import zhongningfu from 'assets/img/casePage/lvjian-zhongningfu.png'
import longyueyasongfu from 'assets/img/casePage/lvjian-longyueyasongfu.jpg'
import dashuju from 'assets/img/casePage/lvjian-dashuju.png'
import yipinhuayuan from 'assets/img/casePage/lvjian-yipinhuayuan.png'
import zhinengzhizao from 'assets/img/casePage/lvjian-zhinengzhizao.png'
import kechuangzhongxin from 'assets/img/casePage/lvjian-kechuangzhongxin.png'
import fuyoubaojianyuan from 'assets/img/casePage/lvjian-fuyoubaojianyuan.png'
import zhongliuyiyuan from 'assets/img/casePage/lvjian-zhongliuyiyuan.jpg'
import xiangshengqiche from 'assets/img/casePage/lvjian-xiangshengqiche.png'
import jinyingshijie from 'assets/img/casePage/lvjian-jinyingshijie.jpg'
import nanjingligong from 'assets/img/casePage/lvjian-nanjingligong.jpg'
import zilanghu from 'assets/img/casePage/lvjian-zilanghu.jpg'

import wuxi from 'assets/img/casePage/lvjian-wuxi.jpg'
import njqh from 'assets/img/casePage/gaizao-njqh.jpg'
import renminzhengfu from 'assets/img/casePage/gaizao-renminzhengfu.png'
import jianyerenminzhengfu from 'assets/img/casePage/gaizao-jianyerenminzhengfu.png'
import qinhuairenminzhengfu from 'assets/img/casePage/gaizao-qinhuairenminzhengfu.jpg'
import shiweidangxiao from 'assets/img/casePage/gaizao-shiweidangxiao.jpg'
import lianyungangzhongyiyuan from 'assets/img/casePage/gaizao-lianyungangzhongyiyuan.png'
import haimenrenminyiyuan from 'assets/img/casePage/gaizao-haimenrenminyiyuan.jpg'

import dahuajieyouhu from 'assets/img/casePage/haimian-dahuajieyouhu.png'
import zhangwanguoji from 'assets/img/casePage/haimian-zhangwanguoji.png'
import zhaoshangzijinzhiguyuan from 'assets/img/casePage/haimian-zhaoshangzijinzhiguyuan.png'
import zhengrongfuhuayuan from 'assets/img/casePage/haimian-zhengrongfuhuayuan.jpg'
import ruigaojinmaofu from 'assets/img/casePage/haimian-ruigaojinmaofu.png'
import jinjixinfeizhizao from 'assets/img/casePage/haimian-jinjixinfeizhizao.png'

import yangzhikangfu from 'assets/img/casePage/bim-yangzhikangfu.png'
import rugaojindujinding from 'assets/img/casePage/bim-rugaojindujinding.png'

const useStyles = makeStyles(styles)

const typeMap = ['绿建咨询', '既有建筑改造', '海绵城市', 'BIM设计']

// 自定义 Skeleton 组件
function CustomSkeleton({ width = '100%', height = '100%', style = {}, animation = 'wave' }) {
  const skeletonStyle = {
    backgroundColor: '#f0f0f0',
    borderRadius: '4px',
    width,
    height,
    position: 'relative',
    overflow: 'hidden',
    ...style,
  }

  const waveStyle = {
    position: 'absolute',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent)',
    animation: animation === 'wave' ? 'skeleton-wave 1.6s linear infinite' : 'none',
  }

  // 添加 CSS 动画关键帧（只在第一次渲染时添加）
  React.useEffect(() => {
    const styleSheet = document.styleSheets[0]
    const keyframes = `
      @keyframes skeleton-wave {
        0% {
          transform: translateX(-100%);
        }
        100% {
          transform: translateX(100%);
        }
      }
    `

    // 检查是否已经存在这个动画
    let animationExists = false
    try {
      for (let i = 0; i < styleSheet.cssRules.length; i++) {
        if (styleSheet.cssRules[i].name === 'skeleton-wave') {
          animationExists = true
          break
        }
      }
    } catch (e) {
      // 忽略跨域错误
    }

    if (!animationExists) {
      try {
        styleSheet.insertRule(keyframes, styleSheet.cssRules.length)
      } catch (e) {
        // 忽略插入失败的情况
      }
    }
  }, [])

  return <div style={skeletonStyle}>{animation === 'wave' && <div style={waveStyle}></div>}</div>
}

const cases = [
  {
    type: '绿建咨询',
    honors: ['LEED CS金级预认证（24、25、26#）'],
    title: '上海BU中心高层办公楼项目',
    img: bu,
  },
  {
    type: '绿建咨询',
    honors: ['健康建筑铂金级（三星级）设计标识', '健康社区铂金级（三星级）设计标识'],
    title: '南京市中宁府（葛洲坝）',
    img: zhongningfu,
  },
  {
    type: '绿建咨询',
    honors: ['健康建筑一星'],
    title: '南京泷悦雅颂府（中电建）',
    img: longyueyasongfu,
  },
  {
    type: '绿建咨询',
    honors: ['绿色建筑三星设计预评价'],
    title: '江宁经济技术开发区大数据中心',
    img: dashuju,
  },
  {
    type: '绿建咨询',
    honors: ['绿色建筑三星'],
    title: '南通中铁逸品花园',
    img: yipinhuayuan,
  },
  {
    type: '绿建咨询',
    honors: ['绿色建筑二星'],
    title: '江北新区研创园智能制造中心',
    img: zhinengzhizao,
  },
  {
    type: '绿建咨询',
    honors: ['绿色建筑二星'],
    title: '南通中央创新区科创中心',
    img: kechuangzhongxin,
  },
  {
    type: '绿建咨询',
    honors: ['绿色建筑二星'],
    title: '南通妇幼保健院儿童综合大楼',
    img: fuyoubaojianyuan,
  },
  {
    type: '绿建咨询',
    honors: ['绿色建筑二星'],
    title: '南通肿瘤医院',
    img: zhongliuyiyuan,
  },
  {
    type: '绿建咨询',
    honors: ['绿色建筑三星'],
    title: '淮安市广瑞翔盛汽车文化展示体验中心',
    img: xiangshengqiche,
  },
  {
    type: '绿建咨询',
    honors: ['绿色建筑二星'],
    title: '南通金鹰世界购物中心',
    img: jinyingshijie,
  },
  {
    type: '绿建咨询',
    honors: ['绿色建筑二星'],
    title: '南京理工大学（江阴校区）',
    img: nanjingligong,
  },
  {
    type: '绿建咨询',
    honors: ['绿色建筑二星'],
    title: '南通市紫琅湖实验学校',
    img: zilanghu,
  },
  {
    type: '绿建咨询',
    honors: ['绿色建筑三星级设计标识'],
    title: '张家港城建档案馆和基础地理信息中心业务用房',
    img: zjg,
  },
  {
    type: '绿建咨询',
    honors: ['绿色建筑二星级运行标识', '2018年度江苏省绿色建筑创新奖二等奖'],
    title: '无锡江南大学数媒经管大楼',
    img: wuxi,
  },
  {
    type: '绿建咨询',
    honors: ['绿色建筑二星级运行标识', '2019年度江苏省绿色建筑创新奖二等奖'],
    title: '南通市通州区市民服务中心',
    img: tz,
  },
  {
    type: '绿建咨询',
    honors: ['绿色建筑三星级设计标识'],
    title: '溧水万达广场B地块住宅项目',
    img: ls,
  },
  {
    type: '既有建筑改造',
    honors: ['既有建筑二星级绿色改造'],
    title: '南京市秦淮区俞家巷19号、21号办公用房改造用房',
    img: njqh,
  },
  {
    type: '既有建筑改造',
    honors: ['费用托管型'],
    title: '安徽天长市人民政府',
    img: renminzhengfu,
  },
  {
    type: '既有建筑改造',
    honors: ['费用托管型'],
    title: '建邺区人民政府',
    img: jianyerenminzhengfu,
  },
  {
    type: '既有建筑改造',
    honors: ['效益分享型'],
    title: '秦淮区人民政府（综合办公）',
    img: qinhuairenminzhengfu,
  },
  {
    type: '既有建筑改造',
    honors: ['效益分享型'],
    title: '中共南京市委党校',
    img: shiweidangxiao,
  },
  {
    type: '既有建筑改造',
    honors: ['费用托管型'],
    title: '连云港市中医院',
    img: lianyungangzhongyiyuan,
  },
  {
    type: '既有建筑改造',
    honors: ['费用托管型'],
    title: '南通市海门区人民医院',
    img: haimenrenminyiyuan,
  },
  {
    type: '海绵城市',
    title: '徐州大华解忧湖三期',
    img: dahuajieyouhu,
  },
  {
    type: '海绵城市',
    title: '万科无锡樟湾国际',
    img: zhangwanguoji,
  },
  {
    type: '海绵城市',
    title: '南京招商紫金智谷产业园',
    img: zhaoshangzijinzhiguyuan,
  },
  {
    type: '海绵城市',
    title: '宿迁正荣府花园',
    img: zhengrongfuhuayuan,
  },
  {
    type: '海绵城市',
    title: '南通如皋金茂府',
    img: ruigaojinmaofu,
  },
  {
    type: '海绵城市',
    title: '金基芯飞智造创新产业园',
    img: jinjixinfeizhizao,
  },
  {
    type: 'BIM设计',
    title: '上海市养志康复医院',
    honors: ['设计施工阶段全专业BIM设计优化', '驻场施工指导'],
    img: jinjixinfeizhizao,
  },
  {
    type: 'BIM设计',
    title: '如皋锦都金鼎大酒店改造项目',
    honors: ['设计施工阶段全专业BIM设计', '驻场施工指导', '二类成果奖项申报'],
    img: rugaojindujinding,
  },
]

// 自定义图片组件，带有加载状态
function ImageWithLoading({ src, alt, className, children, onLoad, onError }) {
  const classes = useStyles()
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState(false)
  const [imageLoaded, setImageLoaded] = React.useState(false)

  const handleImageLoad = () => {
    setLoading(false)
    setImageLoaded(true)
    if (onLoad) onLoad()
  }

  const handleImageError = () => {
    setLoading(false)
    setError(true)
    if (onError) onError()
  }

  React.useEffect(() => {
    const img = new Image()
    img.onload = handleImageLoad
    img.onerror = handleImageError
    img.src = src

    return () => {
      img.onload = null
      img.onerror = null
    }
  }, [src])

  return (
    <div className={className}>
      {loading && (
        <div className={classes.loadingContainer}>
          <CustomSkeleton
            width="100%"
            height="100%"
            animation="wave"
            style={{
              borderRadius: '4px 4px 0 0',
              transform: 'scale(1)',
            }}
          />
        </div>
      )}
      {error && <div className={classes.errorContainer}>图片加载失败</div>}
      <div
        className={classes.imageContainer}
        style={{
          backgroundImage: imageLoaded ? `url(${src})` : 'none',
          opacity: imageLoaded ? 1 : 0,
        }}
      >
        {children}
      </div>
    </div>
  )
}

export default function CasePage(props) {
  const classes = useStyles()
  const { ...rest } = props

  const [value, setValue] = React.useState(0)
  const [projects, setProjects] = React.useState(cases)

  React.useEffect(() => {
    let results
    if (value === 0) {
      results = cases
    } else {
      results = cases.filter(project => typeMap[value - 1] === project.type)
    }
    setProjects(results)
    return () => (results = '')
  }, [value])

  function handleChange(event, newValue) {
    setValue(newValue)
  }

  return (
    <div>
      <MyHeader color="white" brand="江苏硕佰建筑科技有限公司" fixed rightLinks={<MyHeaderLinks />} {...rest} />
      <Parallax small image={require('assets/img/culturePage/culture.jpg')}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <h1 className={classes.title}>典型案例</h1>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <Tabs value={value} onChange={handleChange} indicatorColor="primary" textColor="primary" centered>
            <Tab label="所有" />
            <Tab label="绿建咨询" />
            <Tab label="既有建筑改造" />
            <Tab label="海绵城市" />
            <Tab label="BIM设计" />
          </Tabs>
          <GridContainer>
            {projects.map(project => {
              return (
                <GridItem xs={12} sm={6} md={6} lg={3} key={project.title} className={classes.card}>
                  <Card>
                    <ImageWithLoading src={project.img} alt={project.title} className={classes.media}>
                      <div className={classes.tagRibbon}>
                        <Typography className={classes.mediaTitle}>{project.type}</Typography>
                      </div>
                    </ImageWithLoading>
                    <CardContent>
                      <Typography variant={'h6'} gutterBottom>
                        {project.title}
                      </Typography>
                      <List dense className={classes.list}>
                        {project.honors && project.honors.length > 0
                          ? project.honors.map((honor, index) => {
                              return (
                                <ListItem key={index} className={classes.listItem}>
                                  <ListItemIcon className={classes.prizeIcon}>
                                    <svg className="icon" aria-hidden="true">
                                      <use xlinkHref={`#icon-prize`}></use>
                                    </svg>
                                  </ListItemIcon>
                                  <ListItemText primary={honor} className={classes.listText} />
                                </ListItem>
                              )
                            })
                          : ''}
                      </List>
                    </CardContent>
                  </Card>
                </GridItem>
              )
            })}
          </GridContainer>
        </div>
      </div>
      <MyFooter />
    </div>
  )
}
